import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=815415b8&scoped=true"
import script from "./ListProduct.vue?vue&type=script&lang=ts"
export * from "./ListProduct.vue?vue&type=script&lang=ts"
import style0 from "./ListProduct.vue?vue&type=style&index=0&id=815415b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815415b8",
  null
  
)

export default component.exports